import { ActionContext } from 'vuex'
import TYPES from "./types"
import request from "~/utils/request"
import { config as api } from "~/const/apis"
import { RootState } from '~/store/index'

export interface DynamicLPState {
  slug: string,
  actions: string[],
  conditions: string[]
}

interface State {
  dynamicLP: DynamicLPState[];
}

export const state = (): State => ({
  dynamicLP: []
});

export const getters = {}

export const mutations = {
  [TYPES.SET_DYNAMIC_LP_LIST](state: State, data: DynamicLPState[]) {
    state.dynamicLP = data;
  }
}

export const actions = {
  async getDynamicLpInfo({ commit }: ActionContext<State, RootState>, currentSlug: string) {
    // fetches dynamicLP data from TCC
    try {
      const { data } = await request.get(api.getDynamicLpInfo)
      const dynamicData = data[currentSlug]
      commit(TYPES.SET_DYNAMIC_LP_LIST, dynamicData)
    } catch (error) {
      console.error(error)
    }
  }
}


